import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { AlertMessage } from '../../components/AlertMessage/AlertMessage';

/* SERVICES */
import { getToken } from '../../services/getToken';
import { login } from '../../services/login';

/* IMPORT STYLES FOR LOGIN CONTAINER */ 
import './Login.scss';

export const Login = () => {
    const navigate  = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [loggingSpinner, setLoggingSpinner] = useState(false);

    useEffect(()=>{
    /* On logging out this hook will run on first render and clear all the token related details to previously signed in user.*/ 
    sessionStorage.clear();
    /* GET TOKEN API CALL */ 
        getToken().then((data)=>{
            sessionStorage.setItem('accessToken', JSON.stringify(data.access_token));
            sessionStorage.setItem('tokenCallingTime', JSON.stringify(moment().format()));
        })
    },[])

    const getUsername = (e)=> {
        setUsername(e.target.value);
    }

    const getPassword = (e)=> {
        setPassword(e.target.value);
    }

    const Login = ()=> {
        /* Get the access token to be passed to the login API */ 
        const accessToken = JSON.parse(sessionStorage.getItem('accessToken'));
        setLoggingSpinner(true);
        login(username, password, accessToken).then((data) => {
            sessionStorage.setItem('userAuthorization', JSON.stringify(data.token));

            if(data.user) {
                setLoggingSpinner(false);
                navigate('/query-selection-meter-enquiry', { replace: true });
            } else {
                setLoggingSpinner(false);
                setShowError(true);
                setErrorMessage(data.message);
            }

        });
    }
    
    return (
        <>
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 mx-auto shadow rounded login-background">
                    <div className="login-image">
                        <img height="70px" width="80px" alt="company-logo" src="/images/navabar/tenant-shop-logo.png" />
                    </div>
                    <div className="input-group input-password">
                        <span className="input-group-text" id="Username"><i className="bi bi-people" /></span>
                        <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="Username" onChange={(e)=>getUsername(e)} />
                    </div>
                    <div className="input-group">
                        <span className="input-group-text" id="Password"><i className="bi bi-asterisk" /></span>
                        <input type="password" className="form-control" placeholder="Password" aria-label="Password" aria-describedby="Password" onChange={(e)=>getPassword(e)} />
                    </div>
                    <div className="login-submit-btn">   
                        <button onClick={ ()=>Login() } className="btn btn-primary btn-md login-btn-alignment">
                        { loggingSpinner ? 
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        :
                            "Login"
                        }
                        </button>
                    </div>  
                    <div className="login-alert-message">
                        { showError &&
                            <AlertMessage 
                                message = { errorMessage }
                                alertType = "alert alert-danger"
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
};
